import { Component, OnInit, NgModule } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { GlobalService } from '../services/global.service';
//import {Observable} from 'rxjs/Observable';
import { AuthService } from '../auth/auth.service';
import {throwError} from 'rxjs';  // Updated for Angular 6/RxJS 6

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css']
})

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    declarations: [],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class RegisterComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    error: string;
    showRegistration: boolean;
    checkOAUserForm: FormGroup;
    checkHVAMUserForm: FormGroup;
    registerForm: FormGroup;
    userOrginization;
    message;
    objUser: any;

    public hasCode: boolean = false;
    public showCodeScreen: boolean = true;
    public invitationCode: any = '';

    public codeErr: boolean = false;

    public waitingOnData: boolean = false;
    mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

    public sitePath: string = '';
    public isHVAM: boolean;
    isHVAMCode: boolean;

    //BASE_REG_ENDPOINT = "https://apidev2.hvsfinancial.com/api/CoreRegistration/";
    //BASE_REG_ENDPOINT = "http://api.hvsfinancial.com.loc/api/CoreRegistration/";

    constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService, private fb: FormBuilder, public Global: GlobalService) { 
        this.sitePath = window.location.hostname;
        this.sitePath = this.sitePath.substring(0, this.sitePath.indexOf('.'));
       
        this.isHVAM = (this.sitePath == 'hvam' || this.sitePath == 'hwh') ? true : false;

        // testing purpose
         //this.isHVAM = true;
    }

    ngAfterViewInit() {
        if(this.isHVAM){
    
          console.log('should not be here');
          let head = document.getElementsByTagName('head')[0];
          let style = document.createElement('link');
          style.rel = 'stylesheet';
          style.href = 'assets/css/hvam/hvam-styling.css';
          head.appendChild(style);
          console.log('style', head);
    
        }
      }

    ngOnInit() {
        // reset login status
        //this.authService.logout();
        this.invitationCode = '';

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.showRegistration = false;

        this.checkHVAMUserForm = this.fb.group({
            gNumber: [''],
            username: [''],
            recaptchaReactive: ['', Validators.required]
        });

        this.checkOAUserForm = this.fb.group({
            npn: [''],
            username: [''],
            recaptchaReactive: ['', Validators.required]
        });

        this.registerForm = this.fb.group({
            firstName: [''],
            lastName: [''],
            username: ['', Validators.required],
            email: [''],
            phone: [''],
            password: ['', [Validators.required, Validators.pattern(this.mediumRegex)]],
            confirmPassword: ['', Validators.required],
            question: ['', Validators.required],
            answer: ['', Validators.required]
        });
    }


    searchForOAUser(form: FormGroup) {
        //just added validation here....form invalid wasnt working  
        var body = "{";
        if (form.value.npn == null) {
            if (form.value.username == null) {
                return this.message = "There seemed to be an issue finding your account. Please try again or please contact Support.";
            } else {
                body += '"Email":"' + form.value.username + '"';
            }
        } else {
            body += '"NPN":' + form.value.npn;

        }
        body += "}";

        this.loading = true;
        //console.log("searching...");

        //body += '"Username":' + form.value.UserID + ',';
        //body += '"NPN":' + form.value.npn + ',';
        //body += '"Email":"' + form.value.username + '"';
        //body += "}";

        //console.log(body);

        this.Global.post("CoreRegistration/OAUserSearch", body)
            .subscribe(response => {
                //this.showRegistration = true;
                //console.log('console print:', response);
                if (response) {

                    this.message = '';

                    //console.log(response);
                    this.objUser = Object.assign({}, response);

                    if(this.objUser.FIRST_NAME == '' || this.objUser.FIRST_NAME == undefined || this.objUser.FIRST_NAME == null){
                        return this.message = "We either couldn't find this account in our system, or an account has already been created using this NPN. Please try again, or contact our Support line.";
                    }

                    this.registerForm.patchValue({
                        firstName: this.objUser.FIRST_NAME
                    });

                    this.registerForm.controls['firstName'].setValue(this.objUser.FIRST_NAME);
                    this.registerForm.controls['lastName'].setValue(this.objUser.LAST_NAME);
                    this.registerForm.controls['email'].setValue(this.objUser.Email);

                    //this.registerForm.get("firstName").patchValue(this.objUser.FIRST_NAME);
                    // this.registerForm.get("lastName").setValue(this.objUser.LAST_NAME);
                    //this.registerForm.get("username").setValue(response.Email);
                    // this.registerForm.get("email").setValue(this.objUser.Email);
                    //this.registerForm.get("phone").setValue(response.Phone);

                    this.userOrginization = this.objUser.OFFICE_NAME;

                    this.registerForm.get("firstName").valueChanges.subscribe(
                        (firstName: string) => {
                            if (firstName == null || firstName == '') {
                                this.registerForm.get("firstName").setValidators([Validators.required]);
                                //this.registerForm.get("firstName").updateValueAndValidity();  
                            }
                        }
                    );

                    this.registerForm.get("lastName").valueChanges.subscribe(
                        (lastName: string) => {
                            if (lastName == null || lastName == '') {
                                this.registerForm.get("lastName").setValidators([Validators.required]);
                                // this.registerForm.get("lastName").updateValueAndValidity();   
                            }
                        }
                    );

                    this.registerForm.get("email").valueChanges.subscribe(
                        (email: string) => {
                            this.registerForm.get("email").setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]);
                            // this.registerForm.get("email").updateValueAndValidity();                
                        }
                    );

                    this.showRegistration = true;
                } else if (!response) {
                    this.message = "There seemed to be an issue finding your account. Please try again or please contact Support.";
                } else {
                    this.message = response; //message from server
                }

                this.loading = false;
            },
            err => {
                this.message = "We either couldn't find this account in our system, or an account has already been created using this NPN. Please try again, or contact our Support line.";
                return throwError(err);  // Angular 6/RxJS 6
            });
    }

    searchForHVAMUser(form: FormGroup) {
        //just added validation here....form invalid wasnt working  
        var body = "{";
        if (form.value.npn == null) {
            if (form.value.username == null) {
                return this.message = "There seemed to be an issue finding your account. Please try again or please contact Support.";
            } else {
                body += '"Email":"' + form.value.username + '"';
            }
        } else {
            body += '"GNumber":' + form.value.gNumber;

        }
        body += "}";

        this.loading = true;
        //console.log("searching...");

        //body += '"Username":' + form.value.UserID + ',';
        //body += '"NPN":' + form.value.npn + ',';
        //body += '"Email":"' + form.value.username + '"';
        //body += "}";

        //console.log(body);

        this.Global.post("CoreRegistration/OAUserSearch", body)
            .subscribe(response => {
                //this.showRegistration = true;
                //console.log('console print:', response);
                if (response) {

                    this.message = '';

                    //console.log(response);
                    this.objUser = Object.assign({}, response);

                    if(this.objUser.FIRST_NAME == '' || this.objUser.FIRST_NAME == undefined || this.objUser.FIRST_NAME == null){
                        return this.message = "We either couldn't find this account in our system, or an account has already been created using this NPN. Please try again, or contact our Support line.";
                    }

                    this.registerForm.patchValue({
                        firstName: this.objUser.FIRST_NAME
                    });

                    this.registerForm.controls['firstName'].setValue(this.objUser.FIRST_NAME);
                    this.registerForm.controls['lastName'].setValue(this.objUser.LAST_NAME);
                    this.registerForm.controls['email'].setValue(this.objUser.Email);

                    //this.registerForm.get("firstName").patchValue(this.objUser.FIRST_NAME);
                    // this.registerForm.get("lastName").setValue(this.objUser.LAST_NAME);
                    //this.registerForm.get("username").setValue(response.Email);
                    // this.registerForm.get("email").setValue(this.objUser.Email);
                    //this.registerForm.get("phone").setValue(response.Phone);

                    this.userOrginization = this.objUser.OFFICE_NAME;

                    this.registerForm.get("firstName").valueChanges.subscribe(
                        (firstName: string) => {
                            if (firstName == null || firstName == '') {
                                this.registerForm.get("firstName").setValidators([Validators.required]);
                                //this.registerForm.get("firstName").updateValueAndValidity();  
                            }
                        }
                    );

                    this.registerForm.get("lastName").valueChanges.subscribe(
                        (lastName: string) => {
                            if (lastName == null || lastName == '') {
                                this.registerForm.get("lastName").setValidators([Validators.required]);
                                // this.registerForm.get("lastName").updateValueAndValidity();   
                            }
                        }
                    );

                    this.registerForm.get("email").valueChanges.subscribe(
                        (email: string) => {
                            this.registerForm.get("email").setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]);
                            // this.registerForm.get("email").updateValueAndValidity();                
                        }
                    );

                    this.showRegistration = true;
                } else if (!response) {
                    this.message = "There seemed to be an issue finding your account. Please try again or please contact Support.";
                } else {
                    this.message = response; //message from server
                }

                this.loading = false;
            },
            err => {
                this.message = "We either couldn't find this account in our system, or an account has already been created using this NPN. Please try again, or contact our Support line.";
                return throwError(err);  // Angular 6/RxJS 6
            });
    }

    activateProfile(form: FormGroup) {

        //check if passwords match
        if (form.value.password != form.value.confirmPassword) {
            return this.message = "Please make sure both passwords match.";
        }


        this.loading = true;

        var body = "{";
        //body += '"Username":' + form.value.UserID + ',';
        body += '"FirstName":"' + form.value.firstName + '",';
        body += '"LastName":"' + form.value.lastName + '",';
        //body += '"MiddleName":"' + form.value.NewPassword + '",';
        body += '"Username":"' + form.value.username + '",';
        body += '"Email":"' + form.value.email + '",';
        body += '"Phone":"' + form.value.phone + '",';
        body += '"Password":"' + form.value.password + '",';
        body += '"ROLE_TYPE":"' + this.objUser.ROLE_TYPE + '",'; //RoleID
        //body += '"OrganizationID":' + this.userOrginization + ','; //OFFICE_NAME
        body += '"Producer_Id": ' + this.objUser.Producer_Id + ',';
        body += '"OFFICE_NAME":"' + this.userOrginization + '",';
        body += '"UserAuthQuestion":' + form.value.question + ',';
        body += '"UserAuthAnswer":"' + form.value.answer + '"';

        body += "}";

        // console.log(body);

        this.Global.post("CoreRegistration/OAUserCheck", body)
            .subscribe(response => {
                if (!response) {

                    //check username successfull
                    this.Global.post("CoreRegistration/OARegisterUser", body)
                        .subscribe(response => {
                            if (response) {
                                //after success, forward to the login page => prompt people to login with new creds
                                this.router.navigate(['/login']);
                            } else if (!response) {
                                this.message = "There seemed to be an issue creating your account. Please try again or please contact Support.";
                            } else {
                                this.message = response; //message from server
                            }

                            //this.loading = false;

                        },
                        err => {
                            this.message = "There seemed to be an issue creating your account. Please try again or please contact Support.";
                        });

                } else if (response) {
                    //usernam in use
                    this.message = "This username is currently unavailable. Please choose another username and try again.";
                } else {
                    this.message = response; //message from server
                }

                this.loading = false;

            },
            err => {
                this.message = "There seemed to be an issue creating your account. Please try again or please contact Support.";
            });
    }

    cancel() {
        //display alert and ask if they want to go back to Login page ?

        this.router.navigate(['/login']);
    }

    checkActivateBtn() {
        return this.message = "Is the form disabled: " + (this.registerForm.invalid);
    }

    validateUser() {

    }

    handleEnter(e) {
        if (e.keyCode == 13) {
            // console.log('enter');
            //this.login();
        }
    }

    setCode() {
        this.isHVAMCode = false;
        this.invitationCode = !this.hasCode ? 'NO_CODE' : (this.invitationCode || 0);
        localStorage.setItem('invitationCode', this.invitationCode);
        
        //always set the invitationcode
        this.Global.GetPricing('{"InvitationCode": "' + this.invitationCode + '"}')
        .subscribe(prices => {
            
            if(JSON.parse(prices) != null){
                //console.log('DB Prices:', prices);
                if(JSON.parse(prices).CompletePackageMonthly > 0){

                    if(this.isHVAM && JSON.parse(prices).CompletePackageMonthly == 0.01) {
                        this.showCodeScreen = false;
                        this.showRegistration = false;
                        this.isHVAMCode = true;
                    } else {
                        this.codeErr = false;
                        this.showCodeScreen = false;
                        this.showRegistration = true;
                        this.router.navigateByUrl('/sign-up'); 
                    }                     
                } else {
                    this.showCodeScreen = false;
                    this.showRegistration = false;
                }    
            } else {
                this.codeErr = true;
            }
        });


    }

    setHVAMCode() {
        if(this.hasCode){
            this.isHVAMCode = true;
            //this.invitationCode = !this.hasCode ? 'NO_CODE' : (this.invitationCode || 0);
            localStorage.setItem('invitationCode', this.invitationCode);
            
            //always set the invitationcode
            this.Global.GetPricing('{"InvitationCode": "' + this.invitationCode + '"}')
            .subscribe(prices => {
                
                if(JSON.parse(prices) != null){
                    //console.log('DB Prices:', prices);
                    if(JSON.parse(prices).CompletePackageMonthly > 0){

                        if(this.isHVAM && JSON.parse(prices).CompletePackageMonthly == 0.01) {
                            this.showCodeScreen = false;
                            this.showRegistration = false;
                            this.isHVAMCode = true;
                        } else {
                         
                        }                     
                    } else {
                        this.showCodeScreen = false;
                        this.showRegistration = false;
                    }    
                } else {
                    this.codeErr = true;
                }
            });

        } else {
            this.codeErr = true;
        }
    }

    isToolTipVisible = false; 
    offsetRight = true;   
    mouseEnter() {
        this.message = "Reach out to the organization affiliated with HealthView Asset Management for your Invitation Code.";
        this.isToolTipVisible = true;
    }

    mouseLeave() {
        this.message = '';
        this.isToolTipVisible = false;
    }
}
